"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("./Utils");
var Viewport;
function initViewportMonitoring() {
    if (!Utils_1.isBrowser())
        return;
    var updateViewport = function () {
        Viewport = {
            Height: window.innerHeight,
            Width: window.innerWidth
        };
    };
    updateViewport();
    document.addEventListener('resize', updateViewport);
}
initViewportMonitoring();
var ViewportMonitor = /** @class */ (function () {
    function ViewportMonitor(_a) {
        var _this = this;
        var containerClass = _a.containerClass, itemClass = _a.itemClass, _b = _a.onNewContainer, onNewContainer = _b === void 0 ? null : _b, onNewItem = _a.onNewItem;
        this._isVisible = function (element) {
            var elementBoundingBox = element.getBoundingClientRect();
            var isInViewport = function () {
                var topLeftInViewport = Utils_1.between(elementBoundingBox.top, 0, Viewport.Height) && Utils_1.between(elementBoundingBox.left, 0, Viewport.Width);
                var bottomRightInViewport = Utils_1.between(elementBoundingBox.bottom, 0, Viewport.Height) && Utils_1.between(elementBoundingBox.right, 0, Viewport.Width);
                return topLeftInViewport || bottomRightInViewport;
            };
            var isNotCovered = function () {
                var elementAtPoint = document.elementFromPoint(elementBoundingBox.left, elementBoundingBox.top) || document.elementFromPoint(elementBoundingBox.right, elementBoundingBox.bottom);
                if (!elementAtPoint)
                    return false;
                return elementAtPoint.contains(element) || element.contains(elementAtPoint);
            };
            return isInViewport() && isNotCovered();
        };
        this._initializeContainers = function () {
            var resultContainers = Array.from(document.querySelectorAll("." + _this.containerClass + ":not(." + _this.containerProcessedClass + ")"));
            if (!resultContainers.length)
                return;
            resultContainers.forEach(_this._processContainer);
        };
        this._processContainer = function (container) {
            container.classList.add(_this.containerProcessedClass);
            if (Utils_1.isFunction(_this.onNewContainer))
                _this.onNewContainer(container);
            _this.Containers.push(container);
        };
        this._reset = function () {
            clearInterval(_this._checkItemsInterval);
        };
        this._processItem = function (item, container) {
            item.classList.add(_this.itemProcessedClass);
            if (Utils_1.isFunction(_this.onNewItem))
                _this.onNewItem(item, container);
        };
        this._checkItems = function () {
            if (!_this.Containers)
                return;
            _this.Containers.forEach(function (container) {
                var items = Array.from(container.querySelectorAll("." + _this.itemClass + ":not(." + _this.itemProcessedClass + ")"));
                if (items.length === 0)
                    return;
                items
                    .filter(_this._isVisible)
                    .forEach(function (item) { return _this._processItem(item, container); });
            });
        };
        var salt = "" + Math.floor(Math.random() * 10000);
        this.containerProcessedClass = "js-container-processed-" + salt;
        this.itemProcessedClass = "js-item-processed-" + salt;
        this.containerClass = containerClass;
        this.itemClass = itemClass;
        this.onNewContainer = onNewContainer;
        this.onNewItem = onNewItem;
        this.Containers = [];
        if (Utils_1.isBrowser()) {
            this._initializeContainers();
            this._initializeMutationObserver();
            this._checkItemsInterval = setInterval(this._checkItems, 150);
        }
    }
    ViewportMonitor.prototype._initializeMutationObserver = function () {
        if (!MutationObserver) {
            console.warn('MutationObserver is not supported. Degrading to setInterval');
            this.ObserverInterval = setInterval(this._initializeContainers, 500);
            return;
        }
        var observer = new MutationObserver(this._initializeContainers);
        observer.observe(document, {
            subtree: true,
            childList: true
        });
    };
    return ViewportMonitor;
}());
exports.default = ViewportMonitor;
//# sourceMappingURL=ViewportMonitor.js.map